import { render, staticRenderFns } from "./LicenseeForm.vue?vue&type=template&id=2fc5c892"
import script from "./LicenseeForm.vue?vue&type=script&lang=js"
export * from "./LicenseeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports